/** True if this value should count as an allowed permission (handles legacy string/number). */
function rightIsOn(v) {
  return v === true || v === "true" || v === 1;
}

/** Coerce API/localStorage rights to strict booleans so checks like `=== true` work. */
export function normalizeRightsBooleans(raw) {
  if (!raw || typeof raw !== "object") return {};
  return Object.fromEntries(
    Object.entries(raw).map(([k, v]) => [k, rightIsOn(v)])
  );
}
